module.exports = __webpack_public_path__ + "media/images/log/log-graph-on-b17867b6eeb2d79a64f66e3472b57733.svg";